

import React, { useEffect } from 'react';
import { useState } from 'react';
import ReactPlayer from 'react-player';
import ReactAudioPlayer from 'react-audio-player';
import { LoadAllSchool } from '../actions/Activites/School';
import LoaderBootStrap from '../components/admin/dasboard/LoaderBootStrap';
import { Localvalue } from '../nametitle/localValue';
import AllRoutes from '../nametitle/AllRoutes';
import { AiFillPlayCircle } from 'react-icons/ai';
import { getDataFromFile } from '../actions/SearchAction';


const SchoolBiblePage = () => {
  const [search, setsearch] = useState("");
  const [SchoolList, setSchoolList] = useState([]);
  const [SchoolListSearch, setSchoolListSearch] = useState([]);

  const [video, setvideo] = useState();
  const [audio, setaudio] = useState();
  const [coverPicture, setcoverPicture] = useState();
  const [id, setid] = useState();


  const handleSearch = (e) => {
    e.preventDefault();
    setsearch(e.target.value); //name.includes('J')
    console.log(e.target.value);
    let _users = SchoolListSearch.filter((user) =>
      user.title.toLowerCase().includes(e.target.value.toLowerCase())
    );
    console.log(_users);
    setSchoolList(_users);
  };

  useEffect(() => {
    const objectList = getDataFromFile(Localvalue.enseignementsData);
    setSchoolList(objectList);
    setSchoolList(objectList)
    LoadAllSchool(setSchoolList,setSchoolListSearch);
  }, [])
  return (
    <div className="container-fluid w-full flex flex-col space-y-3 justify-center">


      <div className="col-lg-8 space-y-6 mx-1 my-1">
        <div className="py-2 ">
          <div className="text-3xl font-bold translatable">Vidéos</div>
        </div>
      </div>



      <div className="container min-h-screen">
        <div className="mb-5">
          <div className="input-group">
            <input type="text"  value={search} onChange={(e)=>{handleSearch(e)}} className="form-control p-3 translatable" placeholder="recherche ..." />
            <button className="btn btn-primary px-4"><i className="bi bi-search"></i></button>
          </div>
        </div>

        {/* Items de */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-2 sm:gap-5 md:gap-4 lg:gap-5">
          {
            SchoolList && SchoolList.length > 0 ?
              (
                SchoolList.map((item) => {
                  return (
                    <a className="card hover:bg-lime-200 rounded-lg " style={{ width: "18rem" }} href={`/${AllRoutes.ecole}/${String(item._id).replaceAll(" ", "-")}`}
                      onClick={() => {
                        localStorage.setItem(Localvalue.idSchool, item._id);
                      }}
                    >
                      <div className=" relative z-1">
                      <img className="card-img-top w-full h-[250px] rounded-t-lg" src={item.coverPicture} alt="Card image cap" />
                        <div className="absolute z-5 top-0 left-0  flex justify-center items-center w-full h-full">
                         <AiFillPlayCircle className="h-14 w-12" />
                        </div>
                      </div>
                      <div className="card-body">
                        <h5 className="card-title line-clamp-4 translatable">{item.title}</h5>
                      </div>
                    </a>
                  )
                })
              )
              :
              <LoaderBootStrap />

          }

        </div>



      </div>
    </div>
  )
}

export default SchoolBiblePage;